import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['./customers.component.css'],
    imports: [RouterModule]
})
export class CustomersComponent {
  showMainContent: boolean = true;

  constructor(private router: Router) {
    // Escucha a los eventos de navegación para ajustar la visualización del contenido principal.
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateContentVisibility();
    });
  }

  ngOnInit() {
    // Asegura que la visibilidad del contenido se ajuste correctamente al iniciar/reiniciar el componente.
    this.updateContentVisibility();
  }

  private updateContentVisibility() {
    const path = this.router.url;

    // Lista de rutas que, si están presentes en la URL, deberían ocultar el contenido principal de CustomersComponent.
    const childRoutes = ['/customers/customer-plans', '/customers/view-customer', '/customers/plan-devices', '/customers/customer-users', '/customers/user-update'];

    // Verifica si alguna de las rutas hijo está presente en la URL actual.
    this.showMainContent = !childRoutes.some(route => path.startsWith(route));
  }
}
